import { z } from 'zod';

export const TSDUploadHouseItemsDataSchema = z.object({
  file: z.any().optional(), // File object from express-fileupload,
});
export type TSDUploadHouseItemsData = z.infer<typeof TSDUploadHouseItemsDataSchema>;

export const TSDUploadDownloadHouseItemsDataSchema = TSDUploadHouseItemsDataSchema.merge(
  z.object({
    tsdId: z.string().min(1, { message: 'Required' }),
    houseConsignmentIndex: z.union([z.number(), z.string()]),
    tsdName: z.string().optional(),
  }),
);
export type TSDUploadDownloadHouseItemsData = z.infer<typeof TSDUploadDownloadHouseItemsDataSchema>;
